"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserDAO = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _JsUserDAO2 = require("./JsUserDAO");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UserDAO = /*#__PURE__*/function (_JsUserDAO) {
  (0, _inherits2.default)(UserDAO, _JsUserDAO);

  var _super = _createSuper(UserDAO);

  function UserDAO(mapper, storeInterface, auth, firestore) {
    var _this;

    (0, _classCallCheck2.default)(this, UserDAO);
    _this = _super.call(this, mapper, storeInterface, auth, firestore);
    return (0, _possibleConstructorReturn2.default)(_this, (0, _assertThisInitialized2.default)(_this));
  }

  (0, _createClass2.default)(UserDAO, [{
    key: "subscribeToCurrentUserChanges",
    value: function subscribeToCurrentUserChanges() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "subscribeToCurrentUserChanges", this).call(this);
    }
  }, {
    key: "unsubscribeToCurrentUserChanges",
    value: function unsubscribeToCurrentUserChanges() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "unsubscribeToCurrentUserChanges", this).call(this);
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "getCurrentUser", this).call(this);
    }
  }, {
    key: "refreshCurrentUserState",
    value: function refreshCurrentUserState() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "refreshCurrentUserState", this).call(this);
    }
  }, {
    key: "setCurrentUserDetails",
    value: function setCurrentUserDetails(user) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "setCurrentUserDetails", this).call(this, user);
    }
    /**
     * Updates the details store in Firestore only
     * Does not update core details such as displayName, email etc.
     * @param user
     */

  }, {
    key: "setCurrentUserNonCoreDetails",
    value: function setCurrentUserNonCoreDetails(user) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "setCurrentUserNonCoreDetails", this).call(this, user);
    }
  }, {
    key: "setCurrentUserProfilePicture",
    value: function setCurrentUserProfilePicture() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "setCurrentUserProfilePicture", this).call(this);
    }
  }, {
    key: "getCurrentUserPermissions",
    value: function getCurrentUserPermissions() {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDAO.prototype), "getCurrentUserPermissions", this).call(this);
    }
  }]);
  return UserDAO;
}(_JsUserDAO2.JsUserDAO);

exports.UserDAO = UserDAO;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9kYW8vdXNlci9Vc2VyREFPLnRzIl0sIm5hbWVzIjpbIlVzZXJEQU8iLCJtYXBwZXIiLCJzdG9yZUludGVyZmFjZSIsImF1dGgiLCJmaXJlc3RvcmUiLCJ1c2VyIiwiSnNVc2VyREFPIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7SUFLYUEsTzs7Ozs7QUFFVCxtQkFDSUMsTUFESixFQUVJQyxjQUZKLEVBR0lDLElBSEosRUFJSUMsU0FKSixFQUtFO0FBQUE7O0FBQUE7QUFDRSw4QkFBTUgsTUFBTixFQUFjQyxjQUFkLEVBQThCQyxJQUE5QixFQUFvQ0MsU0FBcEM7QUFDQTtBQUNIOzs7O1dBRUQseUNBQTZDO0FBQ3pDO0FBQ0g7OztXQUVELDJDQUErQztBQUMzQztBQUNIOzs7V0FFRCwwQkFBb0Q7QUFDaEQ7QUFDSDs7O1dBRUQsbUNBQXVDO0FBQ25DO0FBQ0g7OztXQUVELCtCQUE2QkMsSUFBN0IsRUFBcUU7QUFDakUsNEhBQW1DQSxJQUFuQztBQUNIO0FBRUQ7QUFDSjtBQUNBO0FBQ0E7QUFDQTs7OztXQUNJLHNDQUFvQ0EsSUFBcEMsRUFBNEU7QUFDeEUsbUlBQTBDQSxJQUExQztBQUNIOzs7V0FFRCx3Q0FBc0M7QUFDbEM7QUFDSDs7O1dBRUQscUNBQWlFO0FBQy9EO0FBQ0Q7OztFQS9DaURDLHFCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtKc1VzZXJEQU99IGZyb20gJy4vSnNVc2VyREFPJztcbmltcG9ydCB7U3BhcmtlbGxvVXNlcn0gZnJvbSAnLi4vLi4vbW9kZWwnO1xuaW1wb3J0IHtVc2VyTWFwcGVyfSBmcm9tIFwiLi9Vc2VyTWFwcGVyXCI7XG5pbXBvcnQge1VzZXJTdG9yZUludGVyZmFjZX0gZnJvbSBcIi4vVXNlclN0b3JlSW50ZXJmYWNlXCI7XG5cbmV4cG9ydCBjbGFzcyBVc2VyREFPPERTLCBGVSwgQVVUSCwgRklSRVNUT1JFPiBleHRlbmRzIEpzVXNlckRBTyB7XG5cbiAgICBwdWJsaWMgY29uc3RydWN0b3IoXG4gICAgICAgIG1hcHBlcjogVXNlck1hcHBlcjxEUywgRlU+LFxuICAgICAgICBzdG9yZUludGVyZmFjZTogVXNlclN0b3JlSW50ZXJmYWNlPEZVPixcbiAgICAgICAgYXV0aDogQVVUSCxcbiAgICAgICAgZmlyZXN0b3JlOiBGSVJFU1RPUkVcbiAgICApIHtcbiAgICAgICAgc3VwZXIobWFwcGVyLCBzdG9yZUludGVyZmFjZSwgYXV0aCwgZmlyZXN0b3JlKTtcbiAgICAgICAgcmV0dXJuIHRoaXM7XG4gICAgfVxuXG4gICAgcHVibGljIHN1YnNjcmliZVRvQ3VycmVudFVzZXJDaGFuZ2VzKCk6IHZvaWQge1xuICAgICAgICByZXR1cm4gc3VwZXIuc3Vic2NyaWJlVG9DdXJyZW50VXNlckNoYW5nZXMoKTtcbiAgICB9XG5cbiAgICBwdWJsaWMgdW5zdWJzY3JpYmVUb0N1cnJlbnRVc2VyQ2hhbmdlcygpOiB2b2lkIHtcbiAgICAgICAgcmV0dXJuIHN1cGVyLnVuc3Vic2NyaWJlVG9DdXJyZW50VXNlckNoYW5nZXMoKTtcbiAgICB9XG5cbiAgICBwdWJsaWMgZ2V0Q3VycmVudFVzZXIoKTogUHJvbWlzZTxTcGFya2VsbG9Vc2VyPEZVPj4ge1xuICAgICAgICByZXR1cm4gc3VwZXIuZ2V0Q3VycmVudFVzZXIoKTtcbiAgICB9XG5cbiAgICBwdWJsaWMgcmVmcmVzaEN1cnJlbnRVc2VyU3RhdGUoKTogdm9pZCB7XG4gICAgICAgIHJldHVybiBzdXBlci5yZWZyZXNoQ3VycmVudFVzZXJTdGF0ZSgpO1xuICAgIH1cblxuICAgIHB1YmxpYyBzZXRDdXJyZW50VXNlckRldGFpbHModXNlcjogU3BhcmtlbGxvVXNlcjxGVT4pOiBQcm9taXNlPHZvaWQ+IHtcbiAgICAgICAgcmV0dXJuIHN1cGVyLnNldEN1cnJlbnRVc2VyRGV0YWlscyh1c2VyKTtcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBVcGRhdGVzIHRoZSBkZXRhaWxzIHN0b3JlIGluIEZpcmVzdG9yZSBvbmx5XG4gICAgICogRG9lcyBub3QgdXBkYXRlIGNvcmUgZGV0YWlscyBzdWNoIGFzIGRpc3BsYXlOYW1lLCBlbWFpbCBldGMuXG4gICAgICogQHBhcmFtIHVzZXJcbiAgICAgKi9cbiAgICBwdWJsaWMgc2V0Q3VycmVudFVzZXJOb25Db3JlRGV0YWlscyh1c2VyOiBTcGFya2VsbG9Vc2VyPEZVPik6IFByb21pc2U8dm9pZD4ge1xuICAgICAgICByZXR1cm4gc3VwZXIuc2V0Q3VycmVudFVzZXJOb25Db3JlRGV0YWlscyh1c2VyKVxuICAgIH1cblxuICAgIHB1YmxpYyBzZXRDdXJyZW50VXNlclByb2ZpbGVQaWN0dXJlKCkge1xuICAgICAgICByZXR1cm4gc3VwZXIuc2V0Q3VycmVudFVzZXJQcm9maWxlUGljdHVyZSgpO1xuICAgIH1cblxuICAgIHB1YmxpYyBnZXRDdXJyZW50VXNlclBlcm1pc3Npb25zKCk6IFByb21pc2U8UmVjb3JkPHN0cmluZywgYW55Pj4ge1xuICAgICAgcmV0dXJuIHN1cGVyLmdldEN1cnJlbnRVc2VyUGVybWlzc2lvbnMoKTtcbiAgICB9XG59XG4iXX0=